class ProductCard {
  static options = {
    image: false,
    fetch: {
      credentials: 'same-origin',
      cache: 'default',
      redirect: 'error',
      method: 'post',
      headers: {
        'X-Requested-With': 'XmlHttpRequest',
      },
    },
    filename: '',
    timeout: 150,
  };

  constructor(element, options) {
    this._element = element;
    this._options = { ...ProductCard.options, ...options };
    this._cacheSelectors();
    this._initialize();
  }

  _cacheSelectors() {
    this._elements = {
      link: this._element.querySelector(this._options.link),
    };
  }

  _initialize() {
    const types = ['jpeg', 'jpg', 'tiff', 'gif', 'png'];
    const url = this._options.download;
    this._options.image = types.some((el) => url.indexOf(el) > -1);
    /* eslint-disable-next-line */
    this._options.image ? this._initDownload() : null;
  }

  _initDownload() {
    this._elements.link.addEventListener('click', (e) => {
      e.preventDefault();
      this._createDownload();
      return false;
    });
  }

  _createDownload() {
    const url = this._options.download;
    this._options.filename = url.substring(url.lastIndexOf('/') + 1);

    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        this._downloadBlob(blob);
      });
  }

  _downloadBlob(blob) {
    // Create an object URL for the blob object
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = this._options.filename;
    this._options.listener = a.addEventListener('click', this._clickHandler(url), false);
    a.click();
    return a;
  }

  _clickHandler(url) {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      removeEventListener('click', this._clickHandler);
    }, this._options.timeout);
  }
}

export default ProductCard;
